import React from 'react';
import { Link, Navigate } from 'react-router';
import { STUDIO_COPY, STUDIO_DOCUMENT_TITLES } from '../config';
import { useStudioAuth } from '../hooks/useStudioAuth';
import { useStudioDocumentTitle } from '../hooks/useStudioDocumentTitle';

/**
 * Stripe Checkout cancel return — no entitlement change; user can retry upgrade.
 * Production URL: https://scoutlytics.gg/studio/upgrade/cancel
 * (must match RTTS_CHECKOUT_CANCEL_URL).
 */
const StudioUpgradeCancelPage: React.FC = () => {
  useStudioDocumentTitle(STUDIO_DOCUMENT_TITLES.upgradeCancel);
  const { status, isLoggedOut } = useStudioAuth();

  if (status === 'loading') {
    return (
      <div className="flex justify-start py-16">
        <div className="studio-spinner" />
      </div>
    );
  }

  if (isLoggedOut) {
    return <Navigate to="/studio/connect" replace />;
  }

  return (
    <div
      className="studio-page"
      data-testid="studio-upgrade-cancel"
    >
      <div className="studio-panel space-y-4">
        <h1 className="studio-display text-2xl">{STUDIO_COPY.checkoutCanceledHeadline}</h1>
        <p className="studio-page-kicker">
          {STUDIO_COPY.checkoutCanceledBody}
        </p>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/studio/upgrade"
            className="studio-btn-primary no-underline"
            data-testid="studio-upgrade-cancel-retry"
          >
            {STUDIO_COPY.backToPlans}
          </Link>
          <Link
            to="/studio/vods"
            className="studio-btn-ghost no-underline"
            data-testid="studio-upgrade-cancel-vods"
          >
            {STUDIO_COPY.backToVods}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StudioUpgradeCancelPage;
